import React from 'react';
import { createRoot } from 'react-dom/client';
// import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
//import TagManager from 'react-gtm-module';
import ReactGA from './utils/react-ga-compat';

// const tagManagerArgs = {
//   gtmId: 'GTM-P4SN8ZN',
// }
// TagManager.initialize(tagManagerArgs);

ReactGA.initialize('UA-48730246-1', {
    gaOptions: {
        allowLinker: true
    }
});

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <>
    <App />
  </>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
